import { SelectItem } from 'primeng/api';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { TranslocoService } from '@ngneat/transloco';
import { GENDERS } from 'projects/core/src/lib/constants';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AcCompetenceFilterComponent, AcComponentFilterValuesType } from '../../partials/filters/ac-competence-filter/ac-competence-filter.component';
import { AcCompetenceClickedChartDataType, AcCompetenceOverviewChartDataType } from '../../partials/charts/ac-competence-overview-chart/ac-competence-overview-chart.component';
import { CompetenceModel } from 'projects/core/src/lib/models/competence.model';
import { faBoxOpen, faSlidersH } from '@fortawesome/pro-light-svg-icons';
import * as moment from 'moment';

@Component({
  selector: 'app-ac-competence-statistics',
  templateUrl: './ac-competence-statistics.component.html',
  styleUrls: ['./ac-competence-statistics.component.scss']
})
export class AcCompetenceStatisticsComponent implements OnInit {

  loading = false;
  set = false;
  language: string;
  drilldownOpened = false;
  drilldownData: AcCompetenceClickedChartDataType;
  filterValues: AcComponentFilterValuesType | null = null;
  bigChart: boolean = false;

  genders: Array<SelectItem> = [];
  chartData: Array<AcCompetenceOverviewChartDataType> = [];
  acAmount: number | null = null;
  recommendations: any | null = null;

  faBoxOpen = faBoxOpen;
  faSlidersH = faSlidersH;

  @ViewChild('detailFilter') detailFilter: AcCompetenceFilterComponent;

  constructor(
    private api: ApiService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.language = this.transloco.getActiveLang().toUpperCase();
    this.genders = FormHelper.getSelectList(GENDERS, null, this.transloco);
  }

  onFilterSet(filterValues: AcComponentFilterValuesType | null): void {
    this.filterValues = filterValues;
    if (this.filterValues !== null) {
      this.loading = true;
      this.set = true;
      this.api.getStatisticsData('ac/competences', 'overview', this.getFilterPayload(filterValues)).subscribe({
        next: (result: any) => {
          this.acAmount = result.data.acs;
          this.recommendations = result.data.recommendations;
          this.chartData = result.data.ratings.map((entry: any) => {
            return {
              competence: new CompetenceModel().deserialize(entry.competence),
              elements: entry.elements
            };
          });
          this.makeOverallChart();
        }
      }).add(() => {
        this.loading = false;
      });
    }
  }

  onDetailFilterSet(filterValues: AcComponentFilterValuesType): void {
    this.api.getStatisticsData('ac/competences', 'detail', this.getFilterPayload(filterValues)).subscribe({
      next: (result: any) => {
        this.drilldownData = {
          data: result.data
        };
      }
    });
  }

  onBarClicked(data: AcCompetenceClickedChartDataType): void {
    this.drilldownOpened = true;
    this.drilldownData = {
      data: data.data,
      color: data.color
    };
    this.detailFilter.setDetailFilters(data.filters);
  }

  private getFilterPayload(values: AcComponentFilterValuesType): AcComponentFilterValuesType {
      const payload = {...values};
      if (payload.start) {
        payload.start = moment(payload.start).format('YYYY-MM');
      }
      if (payload.end) {
        payload.end = moment(payload.end).format('YYYY-MM');
      }
      return payload;
  }

  private makeOverallChart(): void {
    this.bigChart = false;
    if (this.chartData.length > 1) {
      const chart: AcCompetenceOverviewChartDataType = {
        title: this.transloco.translate('common.labels.overall'),
        elements: {}
      };
      this.chartData.forEach((chartEntry: AcCompetenceOverviewChartDataType) => {
        if (Object.keys(chartEntry.elements).length > 3) {
          this.bigChart = true;
        }
        Object.keys(chartEntry.elements).forEach((key: string) => {
          const element = chartEntry.elements[key];
          if (!chart.elements[key]) {
            chart.elements[key] = {};
          }
          Object.keys(element).forEach((dataKey: string) => {
            if (chartEntry.elements[key][dataKey] && chartEntry.elements[key][dataKey] > 0) {
              if (!chart.elements[key][dataKey]) {
                chart.elements[key][dataKey] = 0;
              }
              chart.elements[key][dataKey] += chartEntry.elements[key][dataKey];
            }
          });
        });
      });
      this.chartData.unshift(chart);
    }
  }

}
